/* eslint-disable no-unused-vars */
import { axiosApiInstance } from '@/api/axios'

const urlBase = '/api/public'

const state = {
  appSettings: {},
  companyLocation: { lat: 41.31124293986933, lng: 69.24456238746643 }
}

const getters = {
  appSettings: (state) => state.appSettings,
  companyLocation: (state) => state.companyLocation
}

const mutations = {
  SET_COMPANY_LOCATION(state, payload) {
    if (!Object.values(payload).some((i) => i === null)) {
      state.companyLocation.lat = payload.lat
      state.companyLocation.lng = payload.long
    }
  },
  SET_APP_SETTINGS(state, payload) {
    state.appSettings = payload
  }
}

const actions = {
  fetchAppSettings({ commit }) {
    axiosApiInstance
      .get(`${urlBase}/get_settings`)
      .then((res) => {
        commit('SET_COMPANY_LOCATION', {
          lat: res.data.lat ? parseFloat(res.data.lat) : null,
          long: res.data.long ? parseFloat(res.data.long) : null
        })

        commit('SET_APP_SETTINGS', res.data)
      })
      .catch((err) => console.log(err))
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
